"use strict";
export var TokenSelectorFlow = /* @__PURE__ */ ((TokenSelectorFlow2) => {
  TokenSelectorFlow2[TokenSelectorFlow2["Swap"] = 0] = "Swap";
  TokenSelectorFlow2[TokenSelectorFlow2["Send"] = 1] = "Send";
  return TokenSelectorFlow2;
})(TokenSelectorFlow || {});
